




























import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { EntryTypes } from "../../domain/account";

@Component({
  components: {
  },
})
export default class ResetAccountPasswordView extends Mixins() {
  data() {
    return {
      isProcessing: false,
      accountCode: "",
      newPassword: "",
      newPasswordForVerify: "",
    };
  }
  isProcessing: boolean;
  accountCode: string;
  newPassword: string;
  newPasswordForVerify: string;
  
  @Prop()
  entryGuid: string;
  
  async created(): Promise<void> {
    this.isProcessing = true;
    try {
      if (!this.entryGuid) { throw new Error("entryGuid is empty!!!"); }
      const repo = DomainRegistry.account.getUnauthenticatedAccountRepository();
      const entry = await repo.getAccountEntry(this.entryGuid, EntryTypes.ResetPassword);
      if (entry.isExpired) {
        this.$error("パスワード再設定", "パスワード再設定情報の有効期限が切れています。");
        return;
      }
      this.accountCode = entry.accountCode;
    } catch (e) {
      this.$error("パスワード再設定", "パスワード再設定情報の取得に失敗しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  async updatePassword(): Promise<void> {
    if (!this.accountCode) {
      this.$warn("パスワード再設定", "ログインID（メールアドレス）の取得に失敗しています。");
      return;
    }
    if (!this.newPassword) {
      this.$warn("パスワード再設定", "新しいパスワードを入力してください。");
      return;
    }
    if (!this.newPasswordForVerify) {
      this.$warn("パスワード再設定", "新しいパスワード(確認)を入力してください。");
      return;
    }
    if (this.newPassword !== this.newPasswordForVerify) {
      this.$warn("パスワード再設定", "パスワードが確認用に入力したものと異なっています。");
      return;
    }

    this.isProcessing = true;
    try {
      const repo = DomainRegistry.account.getUnauthenticatedAccountRepository();
      const result = await repo.resetPassword(this.entryGuid, this.accountCode, this.newPassword);
      if (result.isExpired) {
        this.$warn("パスワード再設定", "処理の有効期限が切れているため、登録できません。");
        return;
      }
      if (!result.isOk) {
        this.$warn("パスワード再設定", "パスワードを変更することができませんでした。");
        return;
      }
      this.$success("パスワード再設定", "パスワードを変更しました。");
      // TODO: 登録成功したらログインまで済ませて画面を遷移したほうがよい？
      this.$router.replace({
        path: "/Login",
        query: {
          defaultAccountCode: this.accountCode,
        },
      });
    } catch (e) {
      this.$error("パスワード再設定", "パスワード再設定処理中にエラーが発生しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  moveToLoginView(): void {
    this.$router.replace({
      path: "/Login",
    });
  }
}
